/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/battery-1214349': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17 7H4a2 2 0 00-2 2v6a2 2 0 002 2h13a2 2 0 002-2V9a2 2 0 00-2-2zm0 8H4V9h13zm4-5a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z"/>'
  }
})
